import React from "react";
import { useTranslation } from "react-i18next";

// Assuming you have a type for your project data
type Sites = {
  name: string;
  adminContact: string;
  location: string;
};

// Mock data - replace this with actual data source
const sitesData: Sites[] = [
  {
    name: "Org A",
    adminContact: "name@email.com",
    location: "Saturn",
  },
  {
    name: "Wildlife Abound",
    adminContact: "name@email.com",
    location: "Iowa",
  },
  {
    name: "Rashel's Organization",
    adminContact: "name@email.com",
    location: "Saturn",
  },
  // ... more projects ...
];

const SitesController: React.FC = () => {
  const { t } = useTranslation();
  // You can implement sorting and filtering logic here

  return (
    <div className="w-3/4 mx-auto">
      <div className="overflow-x-auto">
        <h1 className="text-left text-4xl font-bold mb-4">Sites</h1>
        <table className="w-full bg-white text-left">
          <thead className="bg-green-400">
            <tr>
              <th className="py-2 px-4 font-bold uppercase text-sm text-green-dark border-b border-green-light">
                {t("Name")}
              </th>
              <th className="py-2 px-4 font-bold uppercase text-sm text-green-dark border-b border-green-light">
                Admin Contact
              </th>
              <th className="py-2 px-4 font-bold uppercase text-sm text-green-dark border-b border-green-light">
                Location
              </th>
              <th className="py-2 px-4 font-bold uppercase text-sm text-green-dark border-b border-green-light">
                Model
              </th>
            </tr>
          </thead>
          <tbody>
            {sitesData.map((site, index) => (
              <tr
                key={index}
                className={`border-b ${
                  index % 2 === 0 ? "bg-gray-100" : "bg-white"
                }`}
              >
                <td className="py-2 px-4">{site.name}</td>
                <td className="py-2 px-4">{site.adminContact}</td>
                <td className="py-2 px-4">{site.location}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SitesController;
